import { GridCellProps } from '@progress/kendo-react-grid';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { useInternationalization } from '@progress/kendo-react-intl';
import { FC, useCallback, useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import NumberInput from 'src/components/NumberInput';
import { warningIcon } from 'src/utils/icons';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';

const GlCodesDiscount: FC<GridCellProps> = (props) => {
  const isAutoDistGlBreakout = useContextSelector(
    InvoiceContext,
    (value) => value.invoice.isAutoDistGlBreakout
  );
  const warnings = useContextSelector(InvoiceContext, (value) => value.warnings.discountAmt);
  const isInvoiceEditDisabled = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceEditDisabled
  );
  const setIsGlCodesDirty = useContextSelector(InvoiceContext, (value) => value.setIsGlCodesDirty);

  const { dataItem, field = '', onChange, dataIndex } = props;
  const intl = useInternationalization();

  const handleChange = useCallback(
    (e: TextBoxChangeEvent) => {
      setIsGlCodesDirty(true);
      onChange?.({
        dataIndex,
        dataItem,
        syntheticEvent: e.syntheticEvent,
        field,
        value: e.value,
      });
    },
    [dataIndex, dataItem, field, onChange, setIsGlCodesDirty]
  );
  const { displayValue, value } = useGridCellDisplayValue(props);

  const isTotals = useMemo(() => dataItem.rowId === 'noExpand', [dataItem.rowId]);
  const hasWarnings = useMemo(() => isTotals && !!warnings.length, [warnings.length, isTotals]);

  if (isTotals) {
    const content = (
      <div className={`${isTotals && 'font-bold  flex justify-end items-center'} text-right`}>
        {hasWarnings && warningIcon} {displayValue}
      </div>
    );

    return (
      <GridCellBase
        {...props}
        title={hasWarnings ? warnings?.join(', ') : displayValue}
        className={`${hasWarnings && 'bg-warning bg-opacity-25'}`}
      >
        {content}
      </GridCellBase>
    );
  }

  return (
    <GridCellBase {...props} title={displayValue}>
      {isAutoDistGlBreakout ? (
        <div className="text-right"> {displayValue} </div>
      ) : (
        <div>
          {isInvoiceEditDisabled ? (
            <p className="text-right">{intl.format('{0:c2}', Number(value) || 0)}</p>
          ) : (
            <NumberInput value={value} onChange={handleChange} prefix="$" />
          )}
        </div>
      )}
    </GridCellBase>
  );
};

export default GlCodesDiscount;
